// extracted by mini-css-extract-plugin
export default {"dashNav":"Dashboard_dashNav__ldJ5s"};